import React from 'react';
import { css } from 'aphrodite';
import { AlertCircle } from 'react-feather';

import Button from '~/src/components/Button';
import Banner from '~/src/components/Banner';

import styles from './styles';
import { useRenewSubscriptionConfirmModal } from './useRenewSubscriptionConfirmModal';

export const RenewSubscriptionButton = ({ message }) => {
  const [toggle, modal] = useRenewSubscriptionConfirmModal();

  return (
    <>
      {modal}
      <div className={css(styles.settingsRow)}>
        <Banner small alert Icon={AlertCircle}>
          {message}
        </Banner>
        <Button onClick={toggle} primary>
          Renew Subscription
        </Button>
      </div>
    </>
  );
};
